import { Box, Paper, Stack } from '@mui/material';
import './waiting.scss';

export type LoaderClassNames =
  | "dot-elastic"
  | "dot-pulse"
  | "dot-flashing"
  | "dot-collision"
  | "dot-revolution"
  | "dot-carousel"
  | "dot-typing"
  | "dot-windmill"
  | "dot-bricks"
  | "dot-floating"
  | "dot-fire"
  | "dot-spin"
  | "dot-falling";

interface WaitingProps {
  className?: LoaderClassNames;
  caption?: React.ReactNode;
  borderWidth?: string;
  borderStyle?: string;
  borderColor?: string;
  boxShadow?: string;
  elevation?: number;
  rounded?: boolean;
}

const Waiting: React.FC<WaitingProps> = ({
  className = 'dot-elastic', 
  caption, 
  borderWidth, 
  borderStyle, 
  borderColor, 
  boxShadow, 
  elevation = 1,  // default elevation
  rounded = false  // default rounded value
}) => {
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      flexDirection="column" 
      sx={{
        overflow: 'hidden',
        border: `${borderWidth} ${borderStyle} ${borderColor}`,
        boxShadow: boxShadow
      }}
    >
        <Paper elevation={elevation||0} sx={{ borderRadius: rounded ? '4px' : '0' }}>
          <Stack spacing={2} width={200}>
            {caption && <div>{caption}</div>}
            <div style={{left: "100px"}} className={`theme-orange ${className}`}></div>
          </Stack>
        </Paper>
    </Box>
  );
}

export default Waiting;